import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerRollbackWorkOrderChangeGql } from './rollbackWorkOrderChangeQueries';

export const useRollbackWorkOrderChange = (workOrderId: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [, status, , request, , abort] = useRequest({
        requestId: 'rollbackWorkOrderChange',
        query: uerRollbackWorkOrderChangeGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const makeRollbackHandler = useCallback(() => {
        dispatch(request({ workOrderId }));
    }, [dispatch, request, workOrderId]);

    const isLoading = useMemo(() => status === RequestStatus.FETCHING, [status]);

    const abortRollback = useCallback(() => {
        dispatch(abort());
    }, [dispatch, abort]);

    return useMemo(
        () => ({
            makeRollbackHandler,
            isLoading,
            abortRollback,
        }),
        [abortRollback, isLoading, makeRollbackHandler],
    );
};
